import React from 'react';
import { Link } from 'react-router-dom';
import { IconWorkflow } from './Icons';

/**
 * Link to per-order commission breakdown page.
 * @param {{ orderNo: string, from?: string, placedAt?: string | number }} props
 */
export function CommissionFlowLink({ orderNo, from, placedAt }) {
  if (!orderNo || orderNo === '—') return null;
  return (
    <Link
      to={`/commission-breakdown/${encodeURIComponent(orderNo)}`}
      state={{ from, placedAt: placedAt || undefined }}
      className="btn-table-icon btn-table-icon--flow"
      title="Commission flow"
      aria-label="View commission flow"
    >
      <IconWorkflow size={18} />
    </Link>
  );
}
